import { TriggerForEditor } from "../../../libs/types/src";

export const demoPrivateChannelFlow: Partial<TriggerForEditor> = {
  id: "eee0920c-1117-4577-b24f-ca67962166c2",
  isDraft: true,
  type: "button_click",
  platform: "discord",
  communityId: "1023245510502535178",
  authorUserId: "598367975573291021",
  workspace: "2df1f72b-ef4a-4b83-8ddf-b89bebb53075",
  isActive: true,
  configs: {
    messages: [
      {
        id: "1024782541858799706",
        buttonIds: ["3497e4c8-4c3d-4a1d-8524-ae4b75713793"],
      },
    ],
  },
  name: "Demo Private Channel Onboarding",
  steps: [
    {
      id: "notnil-s-server-test60-ephemeral-demo-step0",
      type: "create_channel",
      configs: {
        userIds: ["{{user.id}}", "598367975573291021"],
        isPrivate: true,
        channelName: "onboard-{{user.username}}",
        channelType: "onboarding",
      },
      isEntry: true,
      isGoal: false,
      transitions: [
        {
          targetStepId: "notnil-s-server-test60-ephemeral-demo-initial-message",
        },
        {
          targetStepId: "$$step-track-all-messages-1023245510502535178",
        },
      ],
    },
    {
      id: "notnil-s-server-test60-ephemeral-demo-initial-message",
      type: "send_message",
      configs: {
        message:
          "Welcome <@{{user.id}}> to the community! We are glad to have you here.",
        channelId: "{{notnil-s-server-test60-ephemeral-demo-step0.channelId}}",
      },
      isEntry: false,
      isGoal: false,
      transitions: [
        {
          targetStepId:
            "notnil-s-server-test60-ephemeral-demo-step-test-captcha",
        },
      ],
    },
    {
      id: "notnil-s-server-test60-ephemeral-demo-step-test-captcha",
      type: "test_captcha",
      configs: {
        userId: "{{user.id}}",
        guildId: "1023245510502535178",
        message:
          "Hey, you're not a robot right? Please solve this captcha to proceed:",
        channelId: "{{notnil-s-server-test60-ephemeral-demo-step0.channelId}}",
      },
      isEntry: false,
      isGoal: false,
      transitions: [
        {
          targetStepId: "notnil-s-server-test60-ephemeral-demo-brings-you-here",
          when: {
            userResponse: {
              type: "captcha-result",
              userId: "{{user.id}}",
              channelId:
                "{{notnil-s-server-test60-ephemeral-demo-step0.channelId}}",
              succeeded: true,
            },
          },
        },
        {
          targetStepId:
            "notnil-s-server-test60-ephemeral-demo-step-test-captcha",
          when: {
            userResponse: {
              type: "captcha-result",
              userId: "{{user.id}}",
              channelId:
                "{{notnil-s-server-test60-ephemeral-demo-step0.channelId}}",
              succeeded: false,
            },
          },
        },
      ],
    },
    {
      id: "notnil-s-server-test60-ephemeral-demo-brings-you-here",
      type: "send_survey",
      configs: {
        type: "buttons",
        message: "\n\n[3/4] **What brings you here**?",
        options: [
          {
            id: "learn",
            emoji: "🎓",
            label: "Learn about your product",
          },
          {
            id: "others",
            emoji: "👥",
            label: "See what others are building",
          },
          {
            id: "trouble",
            emoji: "💻",
            label: "Troubleshoot",
          },
        ],
        channelId: "{{notnil-s-server-test60-ephemeral-demo-step0.channelId}}",
      },
      isEntry: false,
      isGoal: false,
      transitions: [
        {
          targetStepId: "notnil-s-server-test60-ephemeral-demo-step3-student",
          when: {
            userResponse: {
              type: "button",
              userId: "{{user.id}}",
              buttonId: "learn",
              messageId:
                "{{notnil-s-server-test60-ephemeral-demo-brings-you-here.messageId}}",
            },
          },
        },
        {
          targetStepId:
            "notnil-s-server-test60-ephemeral-demo-step3-see-others",
          when: {
            userResponse: {
              type: "button",
              userId: "{{user.id}}",
              buttonId: "others",
              messageId:
                "{{notnil-s-server-test60-ephemeral-demo-brings-you-here.messageId}}",
            },
          },
        },
        {
          targetStepId:
            "notnil-s-server-test60-ephemeral-demo-step3-troubleshoot",
          when: {
            userResponse: {
              type: "button",
              userId: "{{user.id}}",
              buttonId: "trouble",
              messageId:
                "{{notnil-s-server-test60-ephemeral-demo-brings-you-here.messageId}}",
            },
          },
        },
      ],
    },
    {
      id: "notnil-s-server-test60-ephemeral-demo-step3-student",
      type: "send_message",
      configs: {
        message:
          "Dots helps Discord communities improve their member experience by easily creating custom onboarding and support flows. \n\nYou should see sample flows on the left to play around. Feel free to ask any questions in <#958828554097930244>.",
        channelId: "{{notnil-s-server-test60-ephemeral-demo-step0.channelId}}",
      },
      isEntry: false,
      isGoal: false,
      transitions: [
        {
          targetStepId: "notnil-s-server-test60-ephemeral-demo-step4",
        },
      ],
    },
    {
      id: "notnil-s-server-test60-ephemeral-demo-step3-see-others",
      type: "send_message",
      configs: {
        message:
          "Amazing! Please join the discussion on discord automation and bots in <#958828554097930244>. You can also meet others by introducing yourself in <#958902061846626304>.\n              ",
        channelId: "{{notnil-s-server-test60-ephemeral-demo-step0.channelId}}",
      },
      isEntry: false,
      isGoal: false,
      transitions: [
        {
          targetStepId: "notnil-s-server-test60-ephemeral-demo-step4",
        },
      ],
    },
    {
      id: "notnil-s-server-test60-ephemeral-demo-step3-troubleshoot",
      type: "send_message",
      configs: {
        message:
          "Thanks for being an early supporter! You can post your question in <#958902031790276638>.",
        channelId: "{{notnil-s-server-test60-ephemeral-demo-step0.channelId}}",
      },
      isEntry: false,
      isGoal: false,
      transitions: [
        {
          targetStepId: "notnil-s-server-test60-ephemeral-demo-step4",
        },
      ],
    },
    {
      id: "notnil-s-server-test60-ephemeral-demo-step4",
      type: "send_survey",
      configs: {
        type: "buttons",
        message:
          "\n[4/4] Would you want to share your email address so we can keep you updated? We won't spam you!",
        options: [
          {
            id: "yes",
            emoji: "✅",
            label: "Sure!",
          },
          {
            id: "no",
            emoji: "❌",
            label: "No thanks",
          },
        ],
        channelId: "{{notnil-s-server-test60-ephemeral-demo-step0.channelId}}",
      },
      isEntry: false,
      isGoal: false,
      transitions: [
        {
          targetStepId: "notnil-s-server-test60-ephemeral-demo-step-email",
          when: {
            userResponse: {
              type: "button",
              userId: "{{user.id}}",
              buttonId: "yes",
              messageId:
                "{{notnil-s-server-test60-ephemeral-demo-step4.messageId}}",
            },
          },
        },
        {
          targetStepId: "notnil-s-server-test60-ephemeral-demo-final-message",
          when: {
            userResponse: {
              type: "button",
              userId: "{{user.id}}",
              buttonId: "no",
              messageId:
                "{{notnil-s-server-test60-ephemeral-demo-step4.messageId}}",
            },
          },
        },
      ],
    },
    {
      id: "notnil-s-server-test60-ephemeral-demo-step-email",
      type: "send_message",
      configs: {
        message:
          "Please enter your email address. If you prefer not, type skip.",
        channelId: "{{notnil-s-server-test60-ephemeral-demo-step0.channelId}}",
      },
      isEntry: false,
      isGoal: false,
      transitions: [
        {
          targetStepId: "notnil-s-server-test60-ephemeral-demo-waitfor-email",
        },
      ],
    },
    {
      id: "notnil-s-server-test60-ephemeral-demo-waitfor-email",
      type: "idle",
      isEntry: false,
      isGoal: false,
      transitions: [
        {
          targetStepId: "notnil-s-server-test60-ephemeral-demo-final-message",
          when: {
            userResponse: {
              type: "message",
              userId: "{{user.id}}",
              content: {
                has: "email",
              },
              channelId:
                "{{notnil-s-server-test60-ephemeral-demo-step0.channelId}}",
            },
          },
        },
        {
          targetStepId: "notnil-s-server-test60-ephemeral-demo-step-skip-email",
          when: {
            userResponse: {
              type: "message",
              userId: "{{user.id}}",
              content: "skip",
              channelId:
                "{{notnil-s-server-test60-ephemeral-demo-step0.channelId}}",
            },
          },
        },
        {
          targetStepId: "notnil-s-server-test60-ephemeral-demo-step-not-email",
          when: {
            userResponse: {
              and: [
                {
                  content: {
                    hasnot: "email",
                  },
                },
                {
                  content: {
                    neq: "skip",
                  },
                },
              ],
              type: "message",
              userId: "{{user.id}}",
              channelId:
                "{{notnil-s-server-test60-ephemeral-demo-step0.channelId}}",
            },
          },
        },
      ],
    },
    {
      id: "notnil-s-server-test60-ephemeral-demo-step-skip-email",
      type: "send_message",
      configs: {
        message: "Okay, no worries.",
        channelId: "{{notnil-s-server-test60-ephemeral-demo-step0.channelId}}",
      },
      isEntry: false,
      isGoal: false,
      transitions: [
        {
          targetStepId: "notnil-s-server-test60-ephemeral-demo-final-message",
        },
      ],
    },
    {
      id: "notnil-s-server-test60-ephemeral-demo-step-not-email",
      type: "send_message",
      configs: {
        message: "Hmm, this does not look like an email. Please enter again",
        channelId: "{{notnil-s-server-test60-ephemeral-demo-step0.channelId}}",
      },
      isEntry: false,
      isGoal: false,
      transitions: [
        {
          targetStepId: "notnil-s-server-test60-ephemeral-demo-waitfor-email",
        },
      ],
    },
    {
      id: "notnil-s-server-test60-ephemeral-demo-final-message",
      type: "send_message",
      configs: {
        message:
          "\n\n Great! You have access to the server. Thanks for being part of our community! \nPS: This channel will be automatically deleted in 1 hour. Please reach out to us if you have any questions! ",
        channelId: "{{notnil-s-server-test60-ephemeral-demo-step0.channelId}}",
      },
      isEntry: false,
      isGoal: false,
      transitions: [
        {
          targetStepId: "notnil-s-server-test60-ephemeral-demo-step-delete",
        },
      ],
    },
    {
      id: "notnil-s-server-test60-ephemeral-demo-step-delete",
      type: "delete_channel",
      configs: {
        channelId: "{{notnil-s-server-test60-ephemeral-demo-step0.channelId}}",
        delaySeconds: 3600,
      },
      isEntry: false,
      isGoal: true,
      transitions: [],
    },
    {
      id: "$$step-track-all-messages-1023245510502535178",
      type: "idle",
      isEntry: false,
      isGoal: false,
      transitions: [
        {
          targetStepId: "$$step-track-all-messages-1023245510502535178",
          when: {
            userResponse: {
              type: "message",
              userId: "{{user.id}}",
              channelId:
                "{{notnil-s-server-test60-ephemeral-demo-step0.channelId}}",
              markAsExpectedInVars: false,
            },
          },
        },
      ],
    },
  ],
  liveTriggerConfigs: {
    configs: {
      messages: [
        {
          id: "1024782541858799706",
          buttonIds: ["3497e4c8-4c3d-4a1d-8524-ae4b75713793"],
        },
      ],
    },
    type: "button_click",
  },
};
